<script>
    import {onMount} from "svelte";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";
    import {createEventDispatcher} from 'svelte';


    export let mid;
    export let mtype;
    export let model_root;
    export let application_root;

    const dispatch = createEventDispatcher();

    let customContentItems;
    let colNames = [];
    let loaded = false;
    onMount(() => {
        loadCustomContentItems(mid);
    })

    const loadCustomContentItems = async (id, reload = false) => {
        let response = await fetch(model_root + 'shared/contents/load_custom_contents.php?mid=' + id, {
            method: "GET"
        });
        window.scrollTo(0, 0);
        customContentItems = await response.json();
        if (!reload) {
            colNames = Object.keys(customContentItems[0])
        }
        loaded = true;
    }

    export const reloadCustomContentItems = () => {
        loadCustomContentItems(mid, true);
    }

    let sortBy = {col: "id", ascending: true};

    $: sort = (column) => {

        if (sortBy.col == column) {
            sortBy.ascending = !sortBy.ascending
        } else {
            sortBy.col = column
            sortBy.ascending = true
        }

        // Modifier to sorting function for ascending or descending
        let sortModifier = (sortBy.ascending) ? 1 : -1;

        let sort = (a, b) =>
            (a[column] < b[column])
                ? -1 * sortModifier
                : (a[column] > b[column])
                    ? 1 * sortModifier
                    : 0;

        customContentItems = customContentItems.sort(sort);
    }

    const deleteItem = async (id) => {
        if (!confirm(`Soll dieser Inhalt wirklich entfernt werden? Dies kann nicht rückgängig gemacht werden!\n\nBitte beachten Sie, dass hierdurch auch die zugehörigen Bilder und Anhänge unwiderruflich gelöscht werden.`)) {
            return;
        }
        const response = await fetch(model_root + 'admin/contents/delete_custom_content.php?id=' + id, {
            method: "GET"
        }).then(response => response.text());
        if (response === "success") {
            toasts.success('Inhalt gelöscht', 'Der Inhalt wurde erfolgreich gelöscht.', {duration: 3000});
            customContentItems = customContentItems.filter(t => t.id != id)
        } else {
            toasts.error('Ein Fehler ist aufgetreten', response, {duration: 10000});
        }

    }

    const openEditModal = (ccid, ccdata) => {
        dispatch('editCustomContent', {
            mtype: mtype,
            ccid: ccid,
            ccdata: ccdata
        });
    }

    const changeSingleAttribute = (ccid, ccdata, attributeName, newValue) => {
        const newCCData = (({id, ...o}) => o)(ccdata)
        newCCData[attributeName] = newValue;

        const formData = new FormData();
        formData.append("ccid", ccid);
        formData.append("ccdata", JSON.stringify(newCCData));
        const url = model_root + 'admin/contents/update_custom_content.php'
        fetch(url, {
            method: "POST",
            body: formData
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    toasts.success('Attribut geändert', 'Das Attribut wurde erfolgreich geändert.', {duration: 3000});
                    reloadCustomContentItems();
                } else {
                    toasts.error('Ein Fehler ist aufgetreten', msg, {duration: 10000});
                }
            });
    }
</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data}/>
</ToastContainer>

{#if loaded}
    <div class="bg-light rounded pt-3 pb-2 px-3 mt-2">
        <table class="table table-hover">
            <thead>
            <tr>
                {#each colNames as col}
                    <th on:click={() => {sort(col)}} role="button">
                        {col} &varr;
                    </th>
                {/each}
                <th colspan="2"></th>
            </tr>
            </thead>
            <tbody>

            {#each customContentItems as item, index (item.id)}

                <tr>
                    {#each colNames as col, index}
                        <td>
                            {#if typeof item[col] == "boolean"}
                                {#if item[col]}
                                    <i class="far fa-check-circle text-success cursor-pointer"
                                       on:click={() => changeSingleAttribute(item.id, item, col, false)}></i>
                                {:else}
                                    <i class="far fa-times-circle text-danger cursor-pointer"
                                       on:click={() => changeSingleAttribute(item.id, item, col, true)}></i>
                                {/if}
                            {:else if typeof item[col] == "object"}
                                {#if item[col] === null || (Array.isArray(item[col]) && item[col].length === 0)}
                                    <span class="text-muted">[leer]</span>
                                {:else}
                                    <span class="text-muted">[...]</span>
                                {/if}
                            {:else}
                                {item[col]}
                            {/if}
                        </td>
                    {/each}
                    <td role="button" on:click={() => {deleteItem(item.id)}}>
                        <i class="far fa-trash-alt"></i>
                    </td>
                    <td role="button" on:click={()=> {openEditModal(item.id, item)}}>
                        <i class="far fa-edit"></i>
                    </td>
                </tr>
            {/each}

            </tbody>
        </table>
    </div>
{/if}

<style>
    table {
        font-size: 13px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
</style>
